import { render, staticRenderFns } from "./DialogAddLecturesTeacher.vue?vue&type=template&id=362cd224"
import script from "./DialogAddLecturesTeacher.vue?vue&type=script&lang=js"
export * from "./DialogAddLecturesTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('362cd224')) {
      api.createRecord('362cd224', component.options)
    } else {
      api.reload('362cd224', component.options)
    }
    module.hot.accept("./DialogAddLecturesTeacher.vue?vue&type=template&id=362cd224", function () {
      api.rerender('362cd224', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLecturesTeacher.vue"
export default component.exports